export const CHARGEABLE_FEE_TYPE_VALUES = ['standard_rate', 'overage', 'guest_fee', 'bay_premium', 'lesson', 'extension', 'no_show'];
export function toQuotedFees(fees) {
    return fees
        ?.filter((f) => CHARGEABLE_FEE_TYPE_VALUES.includes(f.type))
        .map((f) => ({ type: f.type, baseAmount: f.baseAmount }));
}
//# sourceMappingURL=fees.js.map